import script from "./kyt-change.vue?vue&type=script&setup=true&lang=ts"
export * from "./kyt-change.vue?vue&type=script&setup=true&lang=ts"

import "./kyt-change.vue?vue&type=style&index=0&id=15594355&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15594355"]])

export default __exports__